const columns = [
  {
    key: "deviceCode",
    zh: "整机编号",
    en: "Device Code",
    width: "14%"
  },
  {
    key: "company",
    zh: "公司名称",
    en: "Company",
    width: "16%"
  },
  {
    key: "model",
    zh: "机型",
    en: 'Model',
    width: "8%"
  },
  {
    key: "exhaustPressure",
    zh: "排气压力(MPa)",
    en: "Exhaust Pressure(MPa)",
    width: "11%",
    tooltip: true
  },
  {
    key: "exhaustTemperature",
    zh: "排气温度(℃)",
    en: "Exhaust Temperature(℃)",
    width: "11%",
    tooltip: true
  },
  {
    key: "oilDrumPressure",
    zh: "油分筒压力(MPa)",
    en: "Oil Drum Pressure(MPa)",
    width: "12%",
    tooltip: true
  },
  {
    key: "oilInletPressure",
    zh: "进油压力(MPa)",
    en: "Oil Inlet Pressure(MPa)",
    width: "10%",
    tooltip: true
  },
  {
    key: "oilInletTemperature",
    zh: "进油温度(℃)",
    en: "Oil Inlet Temperature(℃)",
    width: "9%",
    tooltip: true
  },
  {
    key: "percentage",
    zh: "占比",
    en: "Percentage",
    width: "9%",
    tooltip: true
  }
]

export default columns